import { Separator } from "components/custom"
import UserProfileSummary from "features/shared/components/userProfileSummary"
import { joinBytItems, localisedValue } from "utils"

const AllocatedTo = ({ data }) => {
  return (
    <div>
      <div>
        {localisedValue({ key: "name", object: data })}&nbsp;
        {data?.id && <UserProfileSummary staffId={data?.id} />}
      </div>
      <div className="gray-800 fs14">
        {joinBytItems(
          [
            localisedValue({ key: "designationShort", object: data }),
            localisedValue({ key: "regionName", object: data }),
          ],
          <Separator />
        )}
      </div>
    </div>
  )
}

export default AllocatedTo
